import { Navigate, useLocation } from "react-router-dom";
import { useAuth, type AppRole } from "@/contexts/AuthProvider";

interface RequireRoleProps {
  allowed: AppRole[];
  children: React.ReactNode;
}

const RequireRole = ({ allowed, children }: RequireRoleProps) => {
  const { user, role, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground text-sm">Loading…</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  if (!role || !allowed.includes(role)) {
    return <Navigate to="/admin/not-authorized" replace />;
  }

  return <>{children}</>;
};

export default RequireRole;
